import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { HashtagsListComponent } from './hashtags-list.component';
import { DialogComponent } from './dialog/dialog.component';
import { RoleGuard } from '../../../_guards/role.guard';

const routes: Routes = [
    {
        path     : 'hashtagslist',
        component: HashtagsListComponent,
        data :{
            permission:{
                only :['role1','role2']
            }
        },
        canActivate:[AuthGuard,RoleGuard]
    }
];

@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        HashtagsListComponent,
        DialogComponent
    ],
    entryComponents:[
        DialogComponent
    ],
    providers:[
        AuthGuard,RoleGuard
    ]
})
export class HashtagsListModule
{
}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/hashtags-list/hashtags-list.module.ts